
import React, { useState } from 'react';
import * as XLSX from 'xlsx';

function App() {
  const [jsonData, setJsonData] = useState(null);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      const sheetName = wb.SheetNames[0];
      const sheet = wb.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(sheet);

      const formatted = data.map(item => ({
        Name: item["Name"] || "",
        Price: item["Price"] || "",
        SKU: item["SKU"] || "",
        "Standard Category": item["Standard Category"] || ""
      }));

      setJsonData(formatted);
    };

    reader.readAsBinaryString(file);
  };

  const downloadJSON = () => {
    const element = document.createElement("a");
    const file = new Blob([JSON.stringify(jsonData, null, 2)], {
      type: "application/json"
    });
    element.href = URL.createObjectURL(file);
    element.download = "products.json";
    document.body.appendChild(element);
    element.click();
  };

  const maroon = "#800000";

  return (
    <div style={{ fontFamily: 'Arial', padding: 20, backgroundColor: "#fff0f0", minHeight: '100vh' }}>
      <h2 style={{ color: maroon }}>Thurga Admin Uploader</h2>
      <p>Upload your Excel (.xlsx) inventory file below:</p>
      <input type="file" accept=".xlsx" onChange={handleFileUpload} />
      
      {jsonData && (
        <>
          <h3 style={{ marginTop: 20 }}>Preview (First 3 Items):</h3>
          <pre style={{ background: "#fff", padding: 10, border: "1px solid #ccc", maxHeight: 200, overflow: "auto" }}>
            {JSON.stringify(jsonData.slice(0, 3), null, 2)}
          </pre>
          <button onClick={downloadJSON} style={{
            backgroundColor: maroon,
            color: "white",
            padding: "10px 20px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            marginTop: 10
          }}>
            Download products.json
          </button>
        </>
      )}
    </div>
  );
}

export default App;
